var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13.5789C3.20458 13.5789 1.18716 12.4056 0 10.6286C0.022541 8.80776 3.67168 7.80469 5.5 7.80469C7.32832 7.80469 10.9724 8.80776 11 10.6286C9.81284 12.4056 7.79542 13.5789 5.5 13.5789ZM5.5 0.5625C7.01651 0.5625 8.25 1.79599 8.25 3.3125C8.25 4.83527 7.01651 6.0625 5.5 6.0625C3.98349 6.0625 2.75 4.83527 2.75 3.3125C2.75 1.79599 3.98349 0.5625 5.5 0.5625Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.de2cf9674864ded937370df372ca40f6.svg";
export { ForwardRef as ReactComponent };